import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FileUploadFor, FocusInputType, KeyValues5, LocalService, Paging, Wrappers10 } from 'src/service/local.service';
import { ProductManagementService } from 'src/service/product-management.service';

@Component({
  selector: 'app-products-action',
  templateUrl: './products-action.component.html',
  styleUrl: './products-action.component.scss'
})
export class ProductsActionComponent {
  @ViewChild('content_products_action')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() businessId: string = ''; @Input() ctryCode: string = ''; @Input() businessName: string = ''; @Input() paging: Paging;
  FileUploadFor = FileUploadFor; languageVariationCount: string = '';

  htmlId: string = ''; elementIds: any;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private productManagementService: ProductManagementService, private languageManagementService: LanguageManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      btn_upload_file: 'btn_upload_file_' + this.htmlId,
      btn_upload_file_stock: 'btn_upload_file_stock_' + this.htmlId,
      btn_upload_file_add_stock: 'btn_upload_file_add_stock_' + this.htmlId,
      btn_upload_file_overwrite_stock: 'btn_upload_file_overwrite_stock_' + this.htmlId,
    }
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onReset() {
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.productManagementService.downloadProducts(this.businessId, this.ctryCode).subscribe(result => {
          if (result.length > 0) {
            this.localService.onDownloadFile(result, 'Products-' + this.businessName.replace(/ /g, '-') + '_' + this.localService.getDeviceDateWithFormat('DD-MMM-YYYY'));
          }
        });
      } break;
      case 2: {
        this.localService.onFocusNextInput(this.elementIds.btn_upload_file, FocusInputType.Button, true);
      } break;
      case 3:
      case 4: {
        this.productManagementService.getStockReport(this.businessId, index === 4, false, this.paging).subscribe(result => {
          this.localService.onDownloadFile(result, (index === 4 ? 'Stocks' : 'LessStocks-') + '-' + this.businessName.replace(/ /g, '-') + '_' + this.localService.getDeviceDateWithFormat('DD-MMM-YYYY'));
        });
      } break;
      case 5: {
        this.localService.onFocusNextInput(this.elementIds.btn_upload_file_stock, FocusInputType.Button, true);
      } break;
      case 6:
      case 7: {
        this.productManagementService.getStockReport(this.businessId, index === 7, true, this.paging).subscribe(result => {
          this.localService.onDownloadFile(result, 'Price-' + (index === 7 ? 'Stocks' : 'LessStocks-') + '-' + this.businessName.replace(/ /g, '-') + '_' + this.localService.getDeviceDateWithFormat('DD-MMM-YYYY'));
        });
      } break;
      case 8: {
        this.productManagementService.getMonthlyStockReport(this.businessId).subscribe(result => {
          this.localService.onDownloadFile(result, 'UtilizedStocks-' + this.businessName.replace(/ /g, '-') + '_' + this.localService.getDeviceDateWithFormat('DD-MMM-YYYY'));
        });
      } break;
      case 9: {
        this.languageManagementService.correctInvalidProductNameTranslation(this.businessId).subscribe(result => {
          this.languageVariationCount = result.id;
          this.localService.showInformationByStatus(result.status);
        });
      } break;
      case 10: {
        this.productManagementService.getStockCount(this.businessId).subscribe(result => {
          this.onGeneratePdfReportHtml(result);
        });
      } break;
    }
  }

  IsPrint = false; fileName = "stockReport"; printContent = '';
  onGeneratePdfReportHtml(source: Wrappers10) {
    const businessName = source.content?.v1 ?? '';
    const now = new Date();
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const dd = String(now.getDate()).padStart(2, '0');
    const mmm = months[now.getMonth()];
    const yyyy = now.getFullYear();
    const hh = now.getHours() % 12 || 12;
    const min = String(now.getMinutes()).padStart(2, '0');
    const ampm = now.getHours() >= 12 ? 'PM' : 'AM';
    const formattedTime = dd + '-' + mmm + '-' + yyyy + ' ' + hh + ':' + min + ' ' + ampm;
    const totalCount = source.total ?? source.items?.length ?? 0;

    this.printContent = '';
    this.printContent += '<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"><title>Stock Report</title>';
    this.printContent += '<style>';
    this.printContent += 'body { font-family: Arial, sans-serif; margin: 24px; color: #000; background: #fff; }';
    this.printContent += '.report-header { text-align: center; margin-bottom: 14px; }';
    this.printContent += '.report-header h2 { margin: 0 0 4px 0; font-size: 18px; font-weight: 500; }';
    this.printContent += '.report-meta { display: flex; justify-content: center; align-items: center; gap: 24px; font-size: 11px; }';
    this.printContent += 'table { width: 100%; border-collapse: collapse; margin-top: 8px; font-size: 12px; }';
    this.printContent += 'th, td { border: 0.5px solid #000; padding: 5px 10px; text-align: left; }';
    this.printContent += 'th { background: none; color: #000; font-weight: 600; font-size: 12px; text-align: center; }';
    this.printContent += '</style></head>';
    this.printContent += '<body>';

    // Header
    this.printContent += '<div class="report-header">';
    this.printContent += '<h2>' + businessName + '</h2>';
    this.printContent += '<div class="report-meta">';
    this.printContent += '<span>' + formattedTime + '</span>';
    this.printContent += '<span>Total Items: <strong>' + totalCount + '</strong></span>';
    this.printContent += '</div>';
    this.printContent += '</div>';

    // Table
    this.printContent += '<table>';
    this.printContent += '<thead><tr>';
    this.printContent += '<th>#</th>';
    this.printContent += '<th>Code</th>';
    this.printContent += '<th>Product Name</th>';
    this.printContent += '<th>Stock</th>';
    this.printContent += '</tr></thead>';
    this.printContent += '<tbody>';
    (source.items ?? []).forEach((item, index) => {
      this.printContent += '<tr>';
      this.printContent += '<td>' + (index + 1) + '</td>';
      this.printContent += '<td>' + (item.v1 ?? '') + '</td>';
      this.printContent += '<td>' + (item.v4 ?? '') + '</td>';
      this.printContent += '<td>' + (item.v2 ?? '') + '</td>';
      this.printContent += '</tr>';
    });
    this.printContent += '</tbody></table>';



    this.printContent += '</body></html>';

    this.IsPrint = true;
  }

  onPrinted() {
    this.IsPrint = false;
  }
}
